import request from '@/utils/request'
// 物流详情
export function expreessInquiry(params) {
  return request({
    url: '/base/aliyun/expreessInquiry',
    method: 'post',
    params: params
  })
}